/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Search_Alloffertypes2Inputs */

const id_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua Jenis Penawaran`)
};

const ms_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua Jenis Tawaran`)
};

const da_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Tilbudstyper`)
};

const de_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Angebotstypen`)
};

const en_us2_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Offer Types`)
};

const es_es2_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los tipos de oferta`)
};

const es_mx2_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los tipos de oferta`)
};

const fil_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lahat ng Uri ng Offer`)
};

const fr_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les types d'offres`)
};

const it_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti i tipi di offerta`)
};

const hu_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minden ajánlattípus`)
};

const nl_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle aanbodtypes`)
};

const no_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle tilbudstyper`)
};

const pl_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie typy ofert`)
};

const pt_br2_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All offer types`)
};

const pt_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os tipos de oferta`)
};

const ro_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toate tipurile de oferte`)
};

const fi_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaikki tarjoustyypit`)
};

const sv_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alla erbjudandetyper`)
};

const vi_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả loại ưu đãi`)
};

const tr_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm Teklif Türleri`)
};

const cs_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Všechny typy nabídek`)
};

const bg_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всички типове оферти`)
};

const ru_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все типы предложений`)
};

const uk_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Усі типи пропозицій`)
};

const ar_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جميع أنواع العروض`)
};

const hi_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी ऑफ़र प्रकार`)
};

const th_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอทุกประเภท`)
};

const ja_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのオファータイプ`)
};

const zh_cn2_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All offer types`)
};

const zh_hant1_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All offer types`)
};

const ko_components_search_alloffertypes2 = /** @type {(inputs: Components_Search_Alloffertypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All offer types`)
};

/**
* | output |
* | --- |
* | "All Offer Types" |
*
* @param {Components_Search_Alloffertypes2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_search_alloffertypes2 = /** @type {((inputs?: Components_Search_Alloffertypes2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Search_Alloffertypes2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_search_alloffertypes2(inputs)
	if (locale === "ms") return ms_components_search_alloffertypes2(inputs)
	if (locale === "da") return da_components_search_alloffertypes2(inputs)
	if (locale === "de") return de_components_search_alloffertypes2(inputs)
	if (locale === "en-US") return en_us2_components_search_alloffertypes2(inputs)
	if (locale === "es-ES") return es_es2_components_search_alloffertypes2(inputs)
	if (locale === "es-MX") return es_mx2_components_search_alloffertypes2(inputs)
	if (locale === "fil") return fil_components_search_alloffertypes2(inputs)
	if (locale === "fr") return fr_components_search_alloffertypes2(inputs)
	if (locale === "it") return it_components_search_alloffertypes2(inputs)
	if (locale === "hu") return hu_components_search_alloffertypes2(inputs)
	if (locale === "nl") return nl_components_search_alloffertypes2(inputs)
	if (locale === "no") return no_components_search_alloffertypes2(inputs)
	if (locale === "pl") return pl_components_search_alloffertypes2(inputs)
	if (locale === "pt-BR") return pt_br2_components_search_alloffertypes2(inputs)
	if (locale === "pt") return pt_components_search_alloffertypes2(inputs)
	if (locale === "ro") return ro_components_search_alloffertypes2(inputs)
	if (locale === "fi") return fi_components_search_alloffertypes2(inputs)
	if (locale === "sv") return sv_components_search_alloffertypes2(inputs)
	if (locale === "vi") return vi_components_search_alloffertypes2(inputs)
	if (locale === "tr") return tr_components_search_alloffertypes2(inputs)
	if (locale === "cs") return cs_components_search_alloffertypes2(inputs)
	if (locale === "bg") return bg_components_search_alloffertypes2(inputs)
	if (locale === "ru") return ru_components_search_alloffertypes2(inputs)
	if (locale === "uk") return uk_components_search_alloffertypes2(inputs)
	if (locale === "ar") return ar_components_search_alloffertypes2(inputs)
	if (locale === "hi") return hi_components_search_alloffertypes2(inputs)
	if (locale === "th") return th_components_search_alloffertypes2(inputs)
	if (locale === "ja") return ja_components_search_alloffertypes2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_search_alloffertypes2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_search_alloffertypes2(inputs)
	return ko_components_search_alloffertypes2(inputs)
});
export { components_search_alloffertypes2 as "components.search.allOfferTypes" }